import { styled } from 'stitches.config'

export const DeliveryRoot = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  minHeight: '512px',
  backgroundColor: '$primary-700',

  '@bp2': {
    borderRadius: '75px 75px 0px 0px',
  },
})

export const Wrapper = styled('div', {
  maxWidth: '$max',
  padding: '$5 $3',
  position: 'relative',

  '@bp2': {
    padding: '$9 $13',
  },
})
export const MobileImageWrapper = styled('div', {
  width: '100%',
  maxWidth: '625px',

  '@bp2': {
    display: 'none',
  },
})

export const TextContent = styled('div', {
  flex: 1,

  '& button': {
    width: '100%',

    '@bp2': {
      width: 'auto',
    },
  },
})

export const DesktopImageWrapper = styled('div', {
  flex: 1,
  position: 'relative',
  display: 'none',

  '@bp2': {
    display: 'block',
    flex: 1,
  },
})

export const DesktopImage = styled('div', {
  position: 'absolute',

  width: '100%',
  maxWidth: '500px',

  '@bp3': {
    bottom: '-200px',
  },
})
